module.exports = __webpack_public_path__ + "img/puzzle_7.94703043.png";